import React, { SyntheticEvent } from 'react'
import {
  Box,
  Display,
  FlexDirection,
  AlignItems,
  Color,
  Icon,
  IconVariant,
  Text,
  ModalButton,
  ButtonColorVariant,
  ButtonSize,
  Spinner,
} from '@gousto-internal/citrus-react'

type CheckoutButtonProps = {
  isOverLimitBy: number
  maxRecipesInBox: number
  onCheckout: (e: SyntheticEvent) => void
  isCheckoutDisabled: boolean
  isCheckoutPending: boolean
}

export const CheckoutButton = ({
  isOverLimitBy,
  maxRecipesInBox,
  onCheckout,
  isCheckoutDisabled,
  isCheckoutPending,
}: CheckoutButtonProps) => {
  const isDisabled = isOverLimitBy > 0 || isCheckoutDisabled

  return (
    <Box
      display={Display.Flex}
      flexDirection={FlexDirection.Column}
      alignItems={AlignItems.Center}
      bg={Color.White}
      paddingH={[4, 0]}
      width="100%"
    >
      {isOverLimitBy > 0 && (
        <Box display={Display.Flex} alignItems={AlignItems.Center} gap={1} paddingBottom={3}>
          <Icon name="error" variant={IconVariant.Error} />
          <Text color={Color.ColdGrey_800}>
            Max {maxRecipesInBox} recipes fit in a box. Remove <strong>{isOverLimitBy}</strong>{' '}
            recipes.
          </Text>
        </Box>
      )}
      <ModalButton
        colorVariant={ButtonColorVariant.Primary}
        data-testid="checkout-button"
        size={ButtonSize.Large}
        onClick={onCheckout}
        disabled={isDisabled}
        height="48px"
        width={['100%', '400px']}
      >
        {isCheckoutPending ? (
          <Spinner color={Color.White} data-testid="checkout-spinner" size={6} />
        ) : (
          'Checkout'
        )}
      </ModalButton>
    </Box>
  )
}
